module.exports = __webpack_public_path__ + "static/media/fwbz2.0dd9cd31.png";